export default {
    preTitle: 'Overview',
    title: 'Settings',

    tabs: {
        admin: 'Admin platform',
        technician: 'Technician platform'
    }
}